<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nueva Comunicación</v-toolbar-title>
    </v-toolbar>
    <div class="spacing-top">
      <v-card>
        <v-alert :value="customErrorPresent" type="error">{{ customErrorMessage }}</v-alert>
        <v-card-text>
          <form>
            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-text-field v-model="title" :error-messages="titleErrors" label="Título"
                              required @input="$v.title.$touch()" :readonly="saving"></v-text-field>
              </v-flex>
              <v-flex xs3 pl-2>
                <v-autocomplete v-model="departamento" :items="departamentos" itemText="nombre" itemValue="id" label="Departamento"
                                :readonly="saving" :errorMessages="departamentoErrors" @input="$v.departamento.$touch()"
                                :loading="loadingDepartamentos"></v-autocomplete>
              </v-flex>
              <v-flex xs3 pl-2>
                <v-autocomplete v-model="type" :items="types" itemText="title" itemValue="id" label="Tipo de comunicación"
                                :readonly="saving" :errorMessages="typeErrors" @input="$v.type.$touch()"
                                :loading="loadingTypes"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-textarea v-model="message" :error-messages="messageErrors" label="Descripción"
                        required @input="$v.message.$touch()" :readonly="saving"></v-textarea>
            <v-layout row wrap>
              <v-flex xs12>
                <SelectItems v-model="categorias" :items="categoriasNames" itemText="description" itemValue="id"
                             label="Categorías" :loading="loadingCategorias"></SelectItems>
              </v-flex>
              <v-flex xs6 pr-2>
                <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                             label="Grupos a comunicar" :loading="loadingCriterion"></SelectItems>
              </v-flex>
              <v-flex xs6 pl-2>
                <SelectItems v-model="clubes" :items="clubesNames" itemText="nombre" itemValue="pk"
                             label="Clubes" :loading="loadingClubs"></SelectItems>
              </v-flex>
              <v-flex xs12>
                <SelectItems v-model="grupos" :items="gruposNames" itemText="nombre" itemValue="id"
                             label="Grupos predeterminados" :loading="loadingGrupos"></SelectItems>
              </v-flex>
              <v-flex xs12>
                <EmailCombobox ref="emails"></EmailCombobox>
              </v-flex>
            </v-layout>
            <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
            <div v-if="saving">
              <v-progress-linear :indeterminate="true"></v-progress-linear>
              <v-subheader class="right">Cargando, por favor espere.</v-subheader>
            </div>
            <v-btn @click="openFileDirectory" color="primary" :disabled="saving">Agregar adjunto</v-btn>
            <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { recipientsMixin } from '../../../mixins/recipientsMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import AttachFile from '../../../common/ui/AttachFile'
import SelectItems from '../../../common/ui/SelectItems'
import EmailCombobox from '../../../common/ui/EmailCombobox'

const ERROR_MSG_RECIPIENTS = 'Debe seleccionar un grupo a comunicar (y sus clubes) o emails individuales.'

export default {
  mixins: [validationMixin, s3UploadMixin, recipientsMixin],

  validations () {
    return {
      title: { required },
      type: { required },
      message: { required },
      departamento: { required }
    }
  },

  components: {
    EmailCombobox,
    SelectItems,
    AttachFile
  },

  data: () => ({
    loadingTypes: false,
    saving: false,
    files: [],
    types: [],
    type: '',
    errorRecipients: ERROR_MSG_RECIPIENTS,
    apiPath: '/bulletins/new',
    routerPath: 'boletines',
    fetchClubsOnCategorySelection: true,
    loadingDepartamentos: false,
    departamentos: [],
    departamento: null
  }),

  computed: {
    typeErrors () {
      return this.getRequiredErrors('type', 'El tipo es requerido.')
    },
    departamentoErrors () {
      return this.getRequiredErrors('departamento', 'El departamento es requerido')
    }
  },

  methods: {
    isValidForm () {
      if (!this.areCustomValidationsValid()) {
        this.handleCustomErrors()
        return false
      } else {
        this.$refs.emails.validateEmails()
        return !this.$v.$invalid && this.$refs.emails.isValid()
      }
    },
    fetchTypes () {
      this.loadingTypes = true
      this.axios
        .get('bulletins/types')
        .then(response => {
          this.types = response.data
          this.loadingTypes = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      return {
        'title': this.title,
        'description': this.message,
        'assets': this.assets,
        'clubes': this.clubes,
        'person_criteria': this.personas,
        'grupos': this.grupos,
        'emails': this.$refs.emails.getEmails(),
        'communication_type': this.type,
        'departamento': this.departamento
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    fetchDepartamentos () {
      this.loadingDepartamentos = true
      this.axios
        .get('departamentos_by_usuario')
        .then(response => {
          this.departamentos = response.data
          if (this.departamentos.length === 1) {
            this.departamento = this.departamentos[0].id
          }
          this.loadingDepartamentos = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  },

  created () {
    this.fetchData()
    this.fetchTypes()
    this.fetchDepartamentos()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
}
.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}
</style>
